import { QuestionIcon } from '@/app/[locale]/_assets/icon-components'
import { Box } from '@chakra-ui/react'
import Image from 'next/image'
import React from 'react'

type PropType = {
  item: any
  selected: boolean
  index: number
  onClick: () => void
}

export const Thumb: React.FC<PropType> = (props) => {
  const { selected, item, onClick } = props

  const imageUrl = item?.includes(process.env.BASE_URL!)
    ? item
    : process.env.BASE_URL + item

  return (
    <div
      className={'embla-thumbs__slide'.concat(
        selected ? ' embla-thumbs__slide--selected' : ''
      )}
    >
      <button
        onClick={onClick}
        type="button"
        className="embla-thumbs__slide__number"
      >
        {item ? (
          <Image
            src={imageUrl}
            priority={true}
            style={{
              objectFit: 'cover',
            }}
            loading="eager"
            alt={'banner'}
            fill
          />
        ) : (
          <Box>
            <QuestionIcon />
          </Box>
        )}
      </button>
    </div>
  )
}
